/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";
import Dropzone from "components/base/Dropzone";
import { Alert, Button } from "react-bootstrap";
import { clearFiles, selectWizardFiles, syncFilesWithUpload } from "../dataImportWizardSlice";
import { useAppDispatch, useAppSelector } from "pages/thermography/config/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function UploadStep() {
    const { t } = useTranslation();
    const tt = (key: string, options?: Record<string, unknown>) => t(key, { ns: "translation", ...options });
    const dispatch = useAppDispatch();
    const files = useAppSelector(selectWizardFiles);

    const hint = useMemo(() => {
        if (!files.length) return null;
        return tt("pages.thermography.dataImportWizard.upload.selectedFiles", { count: files.length });
    }, [files.length, t]);

    return (
        <div>
            <h5 className="mb-2">{tt("pages.thermography.dataImportWizard.upload.title")}</h5>
            <p className="text-muted mb-3">
                {tt("pages.thermography.dataImportWizard.upload.description")}
            </p>

            <Dropzone
                multiple
                accept={{
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
                    "application/vnd.ms-excel": [".xls"],
                }}
                defaultFiles={files.map((f) => f.file)} // mantém sincronizado ao voltar do passo 2
                onDrop={(acceptedFiles: File[]) => dispatch(syncFilesWithUpload(acceptedFiles))}
                onFilesChange={(currentFiles: File[]) => dispatch(syncFilesWithUpload(currentFiles))}
                dragText={tt("pages.thermography.dataImportWizard.upload.dragText")}
                orText={tt("pages.thermography.dataImportWizard.upload.orText")}
                browseText={tt("pages.thermography.dataImportWizard.upload.browseText")}
                helperText={tt("pages.thermography.dataImportWizard.upload.helperText")}
                icon={<FontAwesomeIcon icon={faFileExcel} className="text-success fs-2" />}
            />

            <div className="mt-3">
                {hint && (
                    <Alert variant="subtle-info" className="py-2 mb-2">
                        {hint}
                    </Alert>
                )}

                {!!files.length && (
                    <div className="d-flex gap-2">
                        <Button variant="outline-danger" onClick={() => dispatch(clearFiles())}>
                            {tt("pages.thermography.dataImportWizard.upload.removeAll")}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
